import { render, staticRenderFns } from "./ManageRequestsItem.vue?vue&type=template&id=1e5d2551&scoped=true&"
import script from "./ManageRequestsItem.vue?vue&type=script&lang=js&"
export * from "./ManageRequestsItem.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequestsItem.vue?vue&type=style&index=0&id=1e5d2551&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d2551",
  null
  
)

export default component.exports